import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class MentalGameAssets {
    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static REEL_BACKGROUND: string = "reelBackground";
    public static BG_LIGHT: string = "bg_light";
    public static BG_LIGHT_CAP: string = "bulb_cap";
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("MentalNumbersWinCountUp", "fonts/bitmapfonts/MentalNumbersWinCountUp.fnt"),
                    new BitmapFontAsset("xnudgeWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp/xNudgeWinCountUp.fnt"),
                    new BitmapFontAsset("NumbersMultiplier", "fonts/bitmapfonts/inhancer box text/NumbersMultiplier.fnt"),
                    new BitmapFontAsset("MultiplierWinCountUp", "fonts/bitmapfonts/multiplier/MultiplierWinCountUp.fnt")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json")
                ],
                animations: {
                    // background
                    "mainBackground": "mainBackground",
                    "bg_light": "bg_light",
                    "bulb_cap": "bulb_cap",
                    "reelBackground": "reelBackground",
                    "reelBackgroundFs": "reelBackgroundFs",

                    // xWaysAnimation
                    "xWaysBackground": "xways_assets/xways_bg",
                    "xWaysTopFrame": "xways_assets/xways_bottom_frame",

                    // "xWaysFrame" :"xways_assets/xways_bottom_frame"
                    "xWaysBottomFrame": "xways_assets/xways_top_frame",
                    "xWaysDivider": "xways_assets/frame_mid_line",

                    // xSplit
                    "xSplitBlood": "xspilt/split_cutting_effect/blood_cut_",
                    "xSplitBackground": "xspilt/xsplit_bg",

                    // dead sym transform
                    "deadBurn": "dead_syms_effect/desolve/burn_effect_",

                    // enhancer Reel Frame
                    "e_top_frame": "reel frame/reelTopFrame", // will use it upside down
                    "e_bottom_frame": "reel frame/reelBottomFrame", // will use it upside down

                    // sticky dead
                    "circleBg": "dead_syms_effect/dead_syms/countup_circle/countup_circle",

                    // win cap
                    "winCapTitle": "big_win/!!!THIS-IS-MENTAL!!!_0000_Layer-2",
                    "winCapX": "big_win/!!!THIS-IS-MENTAL!!!_0004_Group-1",

                    // S2 explosion
                    "s2Explosion": "sym_change/blast_sym_change_",

                    // dead sticky circles
                    "symLock": "fire_frame_lock/lock_M_syms2",

                    // scatter anticipation
                    "coolFsAnticipation": "Fs_anticipation/cool_fs_anticipation/cool_fs_anticipation_",
                    "superFsAnticipation": "Fs_anticipation/super_fs_anticipation/super_fs_anticipation_",

                    // feature indicators
                    "xSplitActive": "Xsplit_active",
                    "xSplitBlink": "Xsplit_shine_blink",
                    "xWaysActive": "Xways_active",
                    "xWaysBlink": "Xways_shine_blink",
                    "xNudgeActive": "Xnudge_active",
                    "xNudgeBlink": "Xnudge_shine_blink",

                    // sticky S2 lock
                    "s2Lock": "S2_lock/s2_bg_lock",

                    // random Feature Intro
                    "randomBonusAutopsy": 'lucky_buy_feature/autopsy',
                    "randomBonusLobotomy": 'lucky_buy_feature/lobotomy',
                    "randomBonusMental": 'lucky_buy_feature/mental',
                    "toggleFrames": "win_toggle/toggle_fire/win_toggle_00000",
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json")
                ],
                animations: {
                    "fsBackground": "fsBackground",
                    "stickyFireFrame": "fireFrame/fireFrame_",

                    // fire frame assets
                    "fireFrameStart": "fire _frame/Coming_fire_frame_blast/fire_frame_start_",
                    "fireFrameLoop": "fire _frame/loop_fire_frame/fire_frame_loop_",
                    "strikeFire": "fire _frame/lightning_effect/lighting_effect_00017_00032",

                    // symbol Split Fire assets
                    "symbolSplitFire": "fire _frame/split_effect/split_effect_000",

                    // enhancer box open assets
                    "doorOpenAnim": "door_open_ani/door_open_ani_000",
                    "boxOpenBlast": "fire _frame/bottom_box_open_blast/bottom_box_open_blast_000",
                    "lightingEffect": "fire _frame/lightning_effect/lighting_effect_00017_000",
                    "door_smoke": "door_smoke/door_smoke_000",

                    // xWays flash light sequence
                    "flashShine": "xways/flash_light_shine/flash_light_shine_",

                    // xNudge
                    "NudgeFireFrame": "Xnudge/fire_blast/fire_blast_",

                    // dead symbol
                    "deadBlast": "dead_syms/blast_multiplier/blast_multiplier_",
                    "deadCutter": "Xsplit/xsplit_cutter.png Comp 1_",
                    "deadAnticipation": "dead_syms/anticipation_fire/anticipation-fire_",
                    "stickyFire": "dead_syms/fire_circle/fire_circle_",
                    "deadShine": "dead_syms/multiplier_rays/rays2",
                    "multBlast": "dead_syms/multiplier_blast/multiplier_blast_",
                    "countBg": "dead_syms/countup_circle/countup_circle",
                    "flyShine": "dead_syms/shine/shine",

                    // win cap
                    "winCapOldMovieEffect": "win_cap/old_movie_effect/old_movie_effect_",

                    // scatter anticipation
                    "s1anticipation": "S1_anticipation/s1_anti_",

                    // big win
                    "bigWinBlast": "big win light/big_win_blast/big_win_blast_",

                    // fs intro stills
                    "autopsy_still": "freespin_intro_images/autopsy",
                    "lobotomy_still": "freespin_intro_images/lobotomy",
                    "mental_still": "freespin_intro_images/mental",

                    // big win anticipation
                    "bigWinAnticipation": "reel_big_win_effect/Comp 1_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "passBy": "S2/passBy/s2_pass_by_",
                }
            },
            {
                name: "assetsWithoutTrimMode",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("assetsWithoutTrimMode0", "sheets/assetsWithoutTrimMode/assetsWithoutTrimMode0.json")
                ]
            },
            {
                name: "freespin",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),
                    new TextureAsset("freespin1", "sheets/freespin/freespin1.json"),
                    new TextureAsset("freespin2", "sheets/freespin/freespin2.json")
                ],
                animations: {
                    "normalSprite": "freespin/autopsy",
                    "coolSprite": "freespin/lobotomy",
                    "superSprite": "freespin/Mental",
                    "upgradeImg": "upgrade_icon"
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("background", "spine/all_bgs.json"),
                    new SpineAsset("bigWinLevel1", "spine/big_win_level_1.json"),
                    new SpineAsset("bigWinLevel2", "spine/big_win_level_2.json"),
                    new SpineAsset("bigWinLevel3", "spine/big_win_level_3.json"),
                    new SpineAsset("bigWinLevel4", "spine/big_win_level_4.json"),
                    new SpineAsset("bigWinLevel5", "spine/big_win_level_5.json"),
                    new SpineAsset("bigWinOldFilm", "spine/old_film_effect.json"),
                    new SpineAsset("bigWinCircle", "spine/elypse.json"),
                    new SpineAsset("Xways", "spine/xways.json"),
                    new SpineAsset("wildNudge", "spine/wildNudge.json"),
                    new SpineAsset("winHighlight", "spine/win_toggle.json"),
                    new SpineAsset("xSplit", "spine/xsplit.json"),
                    new SpineAsset("xSplitKnife", "spine/xsplit_cutter_animation.json"),
                    new SpineAsset("ffLock", "spine/fire_frame _lock.json"),
                    new SpineAsset("fsOutroSpine", "spine/fs_outro.json"),
                    new SpineAsset("winCapSpine", "spine/win_cap.json"),
                    new SpineAsset("winCapOldFilmEffect", "spine/old_film_effect_without_circle.json"),
                    new SpineAsset("D", "spine/D/D.json"),
                    new SpineAsset("DG", "spine/D/DG.json"),
                    new SpineAsset("L1", "spine/L/L1.json"),
                    new SpineAsset("L2", "spine/L/L2.json"),
                    new SpineAsset("L3", "spine/L/L3.json"),
                    new SpineAsset("L4", "spine/L/L4.json"),
                    new SpineAsset("L5", "spine/L/L5.json"),
                    new SpineAsset("M1", "spine/M/M1.json"),
                    new SpineAsset("M2", "spine/M/M2.json"),
                    new SpineAsset("M3", "spine/M/M3.json"),
                    new SpineAsset("M4", "spine/M/M4.json"),
                    new SpineAsset("M5", "spine/M/M5.json"),
                    new SpineAsset("S", "spine/S/S1.json"),
                    new SpineAsset("S2", "spine/S/S2.json"),
                    new SpineAsset("W", "spine/W/wild.json"),
                    new SpineAsset("fsIntro", "spine/intro_splash_new.json")
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null, symbolIndex: number = 1): string {
        let path: string;
        if (stateName == null || stateName == "") {
            path = symbolName + "/" + symbolIndex + "/" + symbolName;
            return path;
        }
        path = symbolName + "/" + symbolIndex + "/" + symbolName + stateName;
        return path;
    }
}
